import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import { CheckCircleIcon } from "@heroicons/react/24/outline"
import { navigate } from "vike/client/router"

const SuccessDialog = ({ isOpen, onClose, texts }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="centered"
      className="md:max-w-md"
      closeOnEscape={true}
      title={texts?.successTitle}
    >
      <div className="flex flex-col items-center gap-5 text-center">
        <CheckCircleIcon className="w-12 h-12 text-success" />

        <p className="text-sm text-text_secondary mt-0 mb-2">
          {texts?.successSubtitle}
        </p>

        <div className="flex flex-col gap-3 w-full">
          <Button 
            variant="primary" 
            onClick={() => navigate("/pricing")} 
            className="w-full"
          >
            {texts?.seeOffers}
          </Button>

          <Button 
            variant="secondary" 
            onClick={onClose} 
            className="w-full"
          >
            {texts?.close}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SuccessDialog
